import React from 'react';

export const SinglePage = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-[#262d37] text-white">
      <h1 className="text-2xl md:text-3xl font-bold">Single Page Version</h1>
    </div>
  );
};
